import React, { ReactNode } from 'react';
import { addMinutes, isValid as isValidDate } from 'date-fns';
import { Controller } from 'react-hook-form';

import { DateTimePicker } from '@mui/x-date-pickers';

type Props = {
  name: string;
  label: ReactNode;
  emptyValue?: undefined | null;
  allowEmptyValue?: boolean;
  size?: 'small' | 'medium';
};

export const FormDatetimeSelectPicker = ({
  name,
  label,
  emptyValue = undefined,
  allowEmptyValue,
  size,
}: Props) => {
  return (
    <Controller
      name={name}
      render={({ field, fieldState }) => {
        return (
          <DateTimePicker
            openTo="day"
            label={label}
            // eslint-disable-next-line
            // @ts-ignore
            minDateTime={addMinutes(new Date(), -6)}
            slotProps={{
              textField: {
                fullWidth: true,
                helperText: fieldState.error?.message,
                error: Boolean(fieldState.error?.message),
                size,
              },
              field: { clearable: false },
            }}
            value={field.value ? field.value : null}
            onChange={(value) => {
              if (!isValidDate(value) && !allowEmptyValue) {
                return;
              }
              field.onChange(value ? value : emptyValue);
            }}
          />
        );
      }}
    />
  );
};
